/**
 * Returns the locale data for the object. If there happens to be locale data stored
 * in the object's metadata too, that will also be returned. If there are duplicate
 * locales between the official locales and the locales found in the metadata,
 * prioritize the official locale data.
 * 
 * @param { object } obj - The object to pull the locale data from.
 * @returns { { locale: string, name: string, description: string }[] }
 */
export function getCourseCurriculumLocaleData( obj ) {
    const locales = obj?.locales || [];
    const metadataLocales = obj?.metadata?.[ 'nonCMXLocales' ] || [];

    // Since we have locale data potentially coming in from the item's metadata (since
    // we may be storing some languages in the metadata since they are not supported by
    // CMX), we want to combine the normal locale data with the list of metadata locales
    // (prioritizing the original locale data).
    const mergedLocales = [ ...locales ];
    for ( let i = 0; i < metadataLocales.length; i++ ) {
        const metadataLocaleData = metadataLocales[ i ];
        const metadataLocaleCode = metadataLocaleData?.locale;
        const alreadyExists = Boolean( mergedLocales.find( localeData => localeData?.code === metadataLocaleCode ) );
        if ( !alreadyExists ) {
            mergedLocales.push( metadataLocaleData );
        }
    }
    
    return mergedLocales;
}
